export default __webpack_public_path__ + "static/media/Boots of Intricate Spite.bc42b52c.jpg";